import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      count: 0,
      isScroll:false,
      flightTableData:null
    },
    mutations: {
      changeIsScroll(state,b){
        state.isScroll = b
      },
      increment (state) {
        state.count++
      },
      inintFlightData(state,data){
        state.flightTableData = data;
      }
    }
  })

  export default store;


// WEBPACK FOOTER //
// ./src/assets/js/vuex.js